'use strict';

function getRootInstancesFromReactMount(ReactMount) {
  return ReactMount._instancesByReactRootID || ReactMount._instancesByContainerID || [];
}

module.exports = getRootInstancesFromReactMount;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/getRootInstancesFromReactMount.js
 ** module id = 60
 ** module chunks = 0
 **/